// Fase 4: wrapper visual para RBAC.
//
// Uso:
//   <AccessGate require="org.sync">
//     <button onClick={syncToday}>Puxar dados</button>
//   </AccessGate>
//
// Renderiza `children` se `can(require)` for verdadeiro, senão `fallback`
// (default: null). NÃO substitui validação no backend — só esconde UI.

import { useAccess } from '../hooks/useAccess.js'

export default function AccessGate({ require, children, fallback = null }) {
  const { can } = useAccess()
  return can(require) ? children : fallback
}
